export const formatDateTime = (timestamp: number): string => {
  const date = new Date(timestamp)
  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

type TimestampLike = {
  toMillis: () => number
}

export const formatTimestamp = (timestamp: TimestampLike): string => {
  return formatDateTime(timestamp.toMillis())
}
